(function () {
  // Prevent multiple global bindings (theme editor can re-run assets)
  if (window.__featuresParticlesBound) return;
  window.__featuresParticlesBound = true;

  const particleIntervals = new WeakMap();

  function createParticleBurst(container) {
    if (!container) return;
    const particleCount = 20;

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("div");
      particle.className = "particle";

      const angle = (Math.PI * 2 * i) / particleCount;
      const distance = 35 + Math.random() * 25;
      const duration = 1 + Math.random() * 0.5;
      const delay = Math.random() * 0.15;

      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;

      particle.style.left = "50%";
      particle.style.top = "50%";
      particle.style.width = 2 + Math.random() * 2 + "px";
      particle.style.height = particle.style.width;

      container.appendChild(particle);

      setTimeout(() => {
        particle.animate(
          [
            { transform: "translate(-50%, -50%) scale(0)", opacity: 0 },
            {
              transform: `translate(calc(-50% + ${x * 0.3}px), calc(-50% + ${y * 0.3}px)) scale(1)`,
              opacity: 1,
              offset: 0.2,
            },
            {
              transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(0.8)`,
              opacity: 0.6,
              offset: 0.6,
            },
            {
              transform: `translate(calc(-50% + ${x * 1.4}px), calc(-50% + ${y * 1.4}px)) scale(0)`,
              opacity: 0,
            },
          ],
          { duration: duration * 1000, easing: "cubic-bezier(0.22, 1, 0.36, 1)" }
        );
      }, delay * 1000);

      setTimeout(() => particle.remove(), (duration + delay) * 1000);
    }
  }

  function createContinuousParticles(container) {
    if (!container) return;
    const particleCount = 5;

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("div");
      particle.className = "particle";

      const angle = Math.random() * Math.PI * 2;
      const distance = 40 + Math.random() * 30;
      const duration = 1.3 + Math.random() * 0.5;

      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;

      particle.style.left = "50%";
      particle.style.top = "50%";
      particle.style.width = 2 + Math.random() * 2 + "px";
      particle.style.height = particle.style.width;

      container.appendChild(particle);

      particle.animate(
        [
          { transform: "translate(-50%, -50%) scale(0)", opacity: 0 },
          {
            transform: `translate(calc(-50% + ${x * 0.4}px), calc(-50% + ${y * 0.4}px)) scale(1)`,
            opacity: 0.9,
            offset: 0.3,
          },
          {
            transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(0.5)`,
            opacity: 0.4,
            offset: 0.7,
          },
          {
            transform: `translate(calc(-50% + ${x * 1.2}px), calc(-50% + ${y * 1.2}px)) scale(0)`,
            opacity: 0,
          },
        ],
        { duration: duration * 1000, easing: "ease-out" }
      );

      setTimeout(() => particle.remove(), duration * 1000);
    }
  }

  function init(sectionRoot) {
    if (!sectionRoot) return;
    if (sectionRoot.dataset.featuresInit === "true") return;
    sectionRoot.dataset.featuresInit = "true";

    const featureItems = sectionRoot.querySelectorAll(".feature-item");

    // IntersectionObserver (scoped)
    const observerOptions = { threshold: 0.2, rootMargin: "0px 0px -100px 0px" };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.style.animationPlayState = "running";
      });
    }, observerOptions);

    featureItems.forEach((item) => {
      item.style.animationPlayState = "paused";
      observer.observe(item);
    });
  }

  // Delegated hover handlers (survive Shopify DOM replacement)
  document.addEventListener("mouseover", (e) => {
    const item = e.target.closest(".feature-item");
    if (!item) return;

    const sectionRoot = item.closest(".features-section");
    if (!sectionRoot) return;

    // Ensure this section is initialized for scroll reveal
    init(sectionRoot);

    const container = item.querySelector(".particles");
    if (!container) return;

    // Avoid duplicate intervals when moving inside same item
    if (particleIntervals.has(item)) return;

    createParticleBurst(container);
    const interval = setInterval(() => createContinuousParticles(container), 250);
    particleIntervals.set(item, interval);
  });

  document.addEventListener("mouseout", (e) => {
    const item = e.target.closest(".feature-item");
    if (!item) return;

    // Only stop when pointer leaves the item completely
    const related = e.relatedTarget;
    if (related && item.contains(related)) return;

    const interval = particleIntervals.get(item);
    if (interval) {
      clearInterval(interval);
      particleIntervals.delete(item);
    }
  });

  // Wait until Shopify injects sections into DOM
  function waitForFeaturesSection() {
    const sections = document.querySelectorAll(".features-section");
    if (sections.length > 0) {
      sections.forEach((sectionRoot) => init(sectionRoot));
    } else {
      requestAnimationFrame(waitForFeaturesSection);
    }
  }
  waitForFeaturesSection();

  // Theme editor re-render
  document.addEventListener("shopify:section:load", (event) => {
    const sectionRoot = event.target.querySelector(".features-section");
    if (sectionRoot) {
      sectionRoot.dataset.featuresInit = "false";
      init(sectionRoot);
    }
  });
})();
